const categoriesMenu = document.querySelector('.categories-menu');
const categoryItems = document.querySelectorAll('.at-category-item');
const subcategoryGroups = document.querySelectorAll('.at-subcategory-group');

/**
 * First category activation on hover
 */
function activateFirstCategory() {
  categoryItems.forEach((item) => item.classList.remove('active'));
  subcategoryGroups.forEach((group) => group.classList.remove('active'));

  const firstItem = categoryItems[0];
  const firstCategory = firstItem.dataset.category;
  const firstGroup = document.querySelector(`.at-subcategory-group[data-category="${firstCategory}"]`);

  if (firstItem && firstGroup) {
    firstItem.classList.add('active');
    firstGroup.classList.add('active');
  }
}

categoryItems.forEach((item) => {
  item.addEventListener('mouseenter', () => {
    categoryItems.forEach((el) => el.classList.remove('active'));
    subcategoryGroups.forEach((group) => group.classList.remove('active'));

    const cat = item.dataset.category;
    const activeGroup = document.querySelector(`.at-subcategory-group[data-category="${cat}"]`);

    item.classList.add('active');
    if (activeGroup) {
      activeGroup.classList.add('active');
    }
  });
});

categoriesMenu.addEventListener('mouseenter', () => {
  activateFirstCategory();
});
